import z from "zod";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const serviceFormSchema = z.object({
	id: z.string().nullish().optional(),
	number: z.number().min(0, "Number must be at least 0").multipleOf(1),
	shortText: z.string().min(1, "Short text is required"),
	longText: z.string().nullish().optional(),
	fulfillmentType: z.enum(["internal", "external"]),
	parentServiceId: ZodStringNullable,
	unit: z.string().min(1, "Unit is required"),
});

export type ServiceFormSchema = z.infer<typeof serviceFormSchema>;
